import { useCallback } from 'react';

export const useAnalytics = () => {
    const trackStepView = useCallback((stepNumber, stepName, additionalData = {}) => {
        const language = localStorage.getItem("language")?.toLowerCase();
        
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": "virtual_page_view",
            "page": {
                "language": language,
                "step number": stepNumber.toString(),
                "name": stepName,
                ...additionalData
            }
        });
    }, []);

    const trackMessage = useCallback((message) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": "message",
            "message": message
        });
    }, []);

    const trackProjectCreation = useCallback((isAxaCustomer, marketingOptIn) => {
        const language = localStorage.getItem("language")?.toLowerCase();
        
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": "virtual_page_view",
            "page": {
                "language": language,
                "event": "virtual_page_view",
                "step number": "5",
                "name": "confirmation",
                "axa client": isAxaCustomer,
                "marketing optin": marketingOptIn ? "true" : "false",
            }
        });
    }, []);

    return {
        trackStepView,
        trackMessage,
        trackProjectCreation
    };
};
